export default __webpack_public_path__ + "static/media/proposalDetail.a757f9d3.png";